<template>
  <div class="toggle" @click="onClick">
    <div
        v-if="textBefore.length"
        :class="[
        'text-uppercase',
        'toggle__text-before',
        isShowCurrentChoiceOnText && value
          ? 'color-secondary'
          : 'color-primary',
      ]"
    >
      {{ textBefore }}
    </div>

    <div
        :class="[
        'toggle__switcher',
        [value ? 'toggle--active' : 'toggle--disabled'],
      ]"
    >
      <div class="toggle__switcher-circle" />
    </div>

    <div
        v-if="textAfter.length"
        :class="[
        'text-uppercase',
        'toggle__text-after',
        isShowCurrentChoiceOnText && !value
          ? 'color-secondary'
          : 'color-primary',
      ]"
    >
      {{ textAfter }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  value: { type: Boolean, required: true },
  textBefore: { type: String, default: "" },
  textAfter: { type: String, default: "" },
  isShowCurrentChoiceOnText: { type: Boolean, default: true },
  // nameID: { type: String, required: true },
});

const emits = defineEmits(["update:value"]);

const onClick = () => {
  emits("update:value", !props.value);
};
</script>

<style lang="scss">
.toggle {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__switcher {
    width: 100px;
    height: 50px;
    border: 2px solid var(--primary-text);
    border-radius: 50px;
    position: relative;
    transition: 2s;

    &-circle {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: var(--primary-text);
      position: absolute;
      top: calc(50% - 20px);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.5s;
    }
  }

  &__text {
    &-before {
      margin-right: 20px;
    }

    &-after {
      margin-left: 20px;
    }
  }

  &--disabled {
    background: transparent;

    .toggle__switcher-circle {
      right: 50px;
    }
  }

  &--active {
    .toggle__switcher-circle {
      right: 5px;
    }
  }

  @media screen and (max-width: 768px) {
    &--disabled {
      .toggle__switcher-circle {
        right: 30px;
      }
    }

    &__switcher {
      width: 60px;
      height: 30px;

      &-circle {
        width: 22px;
        height: 22px;
        top: calc(50% - 11px);
      }
    }

    &__text {
      &-before {
        margin-right: 10px;
      }

      &-after {
        margin-left: 10px;
      }
    }
  }
}
</style>
